import { memo, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import styles from "./styles";

export const DateTime = () => {
  const { t, i18n } = useTranslation();
  const [date, setDate] = useState(new Date());
  const language = i18n.resolvedLanguage;

  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 60000);
    return function cleanup() {
      clearInterval(timer);
    };
  }, []);

  const formattedDate = useMemo(
    () =>
      date.toLocaleDateString(language, {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      }),
    [date, language]
  );

  return (
    <Typography variant="body2" sx={styles.container} className="RlxDateTime">
      {t("Result Date")}: {formattedDate}
    </Typography>
  );
};

DateTime.displayName = "DateTime";

export default memo(DateTime);
